import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {User} from '../models/user';
import {Observable} from 'rxjs';
import {Page} from '../models/page';
import RoleEnum from "../models/enums/roleEnum";
import { of} from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/users';

@Injectable()
export class UserService {

    constructor(private http: HttpClient) {
    }

    findByPage(activity: string, p: number, size: number): Observable<any> {
        const params = new HttpParams()
            .set('activity', String(activity)).set('page', String(p)).set('pageSize', String(size));
        const url = `${apiUrl}/all`;
        return this.http.get<Page>(url, {params});
    }

    setEnable(id, activate) {
        const url = `${apiUrl}/setActivated/${id}?` + 'activated=' + activate;
        return this.http.post(url, httpOptions);
    }

    getById(id: number) {
        const url = `${apiUrl}/${id}`;
        return this.http.get<any>(url);
    }

    saveOrUpdate(user: User) {
        return this.http.post<any>(apiUrl + '/create', user, httpOptions);
    }

    delete(id: number) {
        const url = `${apiUrl}/${id}`;
        return this.http.delete<User>(url, httpOptions);
    }

    invite(invitationRequest: any) {
        const url = `${apiUrl}/invite`;
        return this.http.post<any>(url, invitationRequest, httpOptions);
    }

    acceptInvitation(acceptInvitationRequest: any) {
        const url = `${apiUrl}/accept-invitation`;
        return this.http.post<any>(url, acceptInvitationRequest, httpOptions);
    }

    findAllBasic(roles: string[]): Observable<any> {
        let params = new HttpParams();
            if (roles && roles.length > 0 ) {
                params = params.set('roles', String(roles));
            }

        const url = `${apiUrl}/all-basic`;
        return this.http.get<any>(url, {params});
    }

    findByIds(ids: number[]): Observable<any> {
        if (ids && ids.length>0 && String(ids) && String(ids)!=''){
            const params = new HttpParams()
                .set('ids', String(ids));
            const url = `${apiUrl}/findByIds`;
            return this.http.get<any>(url, {params});
        } else {
            return of();
        }
    }

    exportAllUsers() {
        return this.http.get(`${apiUrl}/export-user-excel`, {responseType: 'blob'});
    }

}
